import * as React from 'react';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';

import { CalculationsBaseStore, } from 'eTip--common';

import { ProgressContent, TicketBets, TicketWinWithErrors } from 'common--design-library';

import { translationForMts } from 'easit--localization';


export interface ITicketCalculationsProps {
    selectionCount: number;
    calculations: Instance<typeof CalculationsBaseStore> | null;
}

@observer
export class TicketCalculationsContainer extends React.Component<ITicketCalculationsProps> {
    constructor(props: ITicketCalculationsProps) {
        super(props);
    }

    get combinationStore() {
        return this.props.calculations;
    }


    render() {
        return (
            <div className="coupon-tips calculations">
                <div className="coupon-tips-label d-flex align-items-center justify-content-between"
                    onClick={() => { this.combinationStore.toggleExpandCalculations(); }}
                >
                    {translationForMts().ticket_Calculations}
                    <span className={`fa toogle-icon ${this.combinationStore.isCalculationExpanded ? 'fa-angle-down' : 'fa-angle-left'}`}></span>
                </div>
                {
                    this.combinationStore.isCalculationExpanded &&
                    <ProgressContent state={this.combinationStore.state}>
                        <TicketWinWithErrors items={[...this.combinationStore.potentialWinWithErrors]} />
                        <TicketBets bets={[...this.combinationStore.bets]} />
                    </ProgressContent>
                }
            </div>
        )
    }
}